"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingCoreSupplierChangedEventTypeEnum = void 0;
var BillingCoreSupplierChangedEventTypeEnum;
(function (BillingCoreSupplierChangedEventTypeEnum) {
  /** Создан новый поставщик */
  BillingCoreSupplierChangedEventTypeEnum["CREATED"] = "CREATED";
  /** Обновлён существующий */
  BillingCoreSupplierChangedEventTypeEnum["UPDATED"] = "UPDATED";
  /** Активирован другой поставщик */
  BillingCoreSupplierChangedEventTypeEnum["ACTIVE_STATUS_CHANGED"] = "ACTIVE_STATUS_CHANGED";
  /** Изменился статус валидации */
  BillingCoreSupplierChangedEventTypeEnum["STATUS_CHANGED"] = "STATUS_CHANGED";
  /** Удалён */
  BillingCoreSupplierChangedEventTypeEnum["REMOVED"] = "REMOVED";
})(BillingCoreSupplierChangedEventTypeEnum = exports.BillingCoreSupplierChangedEventTypeEnum || (exports.BillingCoreSupplierChangedEventTypeEnum = {}));
